module.exports = __webpack_public_path__ + "89a58898b9e38f2b697e423bfa8d298f.png";